import { subtractDays } from 'Utils/dates';
import { FormattedDate } from 'Utils/formattedDate';
import { convertObjectToArray } from './combinedAnalyticsHelpers';

let filterStore = {}; // This will store selected filters.
export const addFilter = (key: string, value: any) => {
  filterStore[key] = value;
};
export const removeFilter = (key: string) => {
  delete filterStore[key];
};

export const selectedFilters = () =>
  // Return the selected filters and their values as strings
  convertObjectToArray(filterStore);

export const clearCombinedAnalyticsFilterStore = () => {
  // Reset the store, when we come back to the explore View
  filterStore = {};
};

/** *********************Engagement*************************** */
const defaultTotalTimeSpent = {
  value: {
    vt: { lower: 1, upper: 15 },
    iwc: { lower: 1, upper: 15 },
  },
};
const TotalTimeSpentModel = {
  filterCategory: 'Engagement',
  filterName: '',
  filterValue: '',
  addToStore: true,
};
const totalTimeSpent = (label: string, totalTimeSpentData: any) => {
  /*
      If the label is undefined, then we are moving one of the sliders.  These are the values we want.
      
      Else
        If the label has a value, we just want to send the timespent data.


        Determine the event and send the current data from TimeSpent.


        If label is present
          Swap out the value of totalTimeSpentData.selection with the label.
            Send the data.
            
        Else the label is undefined,
          Do it as I'm doing now.


    */
  const isLabelUndefined = typeof label === 'undefined';

  if (isLabelUndefined) {
    const selected = totalTimeSpentData.selection;
    switch (selected.toLocaleUpperCase()) {
      case 'VT':
      case 'IWC': {
        const selectedData =
          totalTimeSpentData.value[selected.toLocaleLowerCase()];
        TotalTimeSpentModel.filterName = `TotalTimeSpentinMyVtandorIWC.${selected}`;
        TotalTimeSpentModel.filterValue = `${selectedData.lower} min - ${selectedData.upper} + mins`;
        TotalTimeSpentModel.addToStore = selected !== 'Any';
        return TotalTimeSpentModel;
      }
      default: {
        const { vt } = totalTimeSpentData.value;
        const { iwc } = totalTimeSpentData.value;
        TotalTimeSpentModel.filterName = `TotalTimeSpentinMyVtandorIWC.${selected}`;
        TotalTimeSpentModel.filterValue = `VT ${vt.lower} min - ${vt.upper} + mins, IWC ${iwc.lower} min - ${iwc.upper} + mins`;
        TotalTimeSpentModel.addToStore = selected !== 'Any';
        return TotalTimeSpentModel;
      }
    }
  } else {
    // Label is present, update the Selection with the label value and send the event.
    // Check if the label has a value of Any
    const isAny = label.toLocaleUpperCase() === 'ANY';

    // If the label is any, we need to send default values only.  TotalTimeSpent is not updated right away with the correct values
    const filter = isAny ? defaultTotalTimeSpent : totalTimeSpentData;

    const { vt } = filter.value;
    const { iwc } = filter.value;

    TotalTimeSpentModel.filterName = `Engagement.TotalTimeSpentinMyVtandorIWC.${label}`;
    TotalTimeSpentModel.filterValue = `VT ${vt.lower} min - ${vt.upper} + mins, IWC ${iwc.lower} min - ${iwc.upper} + mins`;
    TotalTimeSpentModel.addToStore = isAny;
    return TotalTimeSpentModel;
  }
};

// Defautl obj for dateRegisteredData
const dateRegisteredData = {
  filterCategory: 'Engagement',
  filterName: 'DateRegisteredwithMyInstitution',
  filterValue: '',
  addToStore: true,
};
const dateRegistered = (data: any) => {
  // Check if value is a string or an object
  const { value } = data;
  if (typeof value === 'string') {
    // Check the id to see what the default is
    switch (value.toLocaleLowerCase()) {
      case 'any':
        dateRegisteredData.filterValue = 'Any';
        break;
      case 'select recency':
        dateRegisteredData.filterValue = 'Select Recency : Within_Last_30_Days';
        break;
      case 'specific date range': {
        // Prod default range is 3 days before today and 1 day before today
        const lower = subtractDays(3);
        const upper = subtractDays(1);

        dateRegisteredData.filterValue = `Specific Date Range : lower ${FormattedDate(
          lower.toUTCString()
        )} - upper ${FormattedDate(upper.toUTCString())}`;
        break;
      }
      default:
        break;
    }
  } else {
    // value is an object.
    switch (data.id.toLocaleLowerCase()) {
      case 'select recency': {
        const { value: RecencyValue } = value;

        dateRegisteredData.filterValue = `Select Recency : ${RecencyValue}`;
        break;
      }
      case 'specific date range': {
        const { lower, upper } = value;
        dateRegisteredData.filterValue = `Specific Date Range : lower ${lower} - upper ${upper}`;
        break;
      }
      default:
        break;
    }
  }
  return dateRegisteredData;
};

const activityWithEabNetworkData = {
  filterCategory: 'Engagement',
  filterName: 'ActivityWithEabNetwork',
  filterValue: '',
  addToStore: true,
};
const activityWithEabNetwork = (data: any) => {
  // Check if value is a string or an object

  const { value } = data;
  if (typeof value === 'string') {
    // Check the id to see what the default is
    switch (value.toLocaleLowerCase()) {
      case 'any':
        activityWithEabNetworkData.filterValue = 'Any';
        break;
      case 'active':
        activityWithEabNetworkData.filterValue = 'Active Within_Last_30_Days';
        break;
      case 'inactive':
        activityWithEabNetworkData.filterValue = 'InActive Within_Last_30_Days';
        break;
      default:
        break;
    }
  } else {
    // value is an object.
    const { value: ActiveValue } = value;
    const { id } = data;

    activityWithEabNetworkData.filterValue = `${id} ${ActiveValue}`;
  }
  return activityWithEabNetworkData;
};

const activityWithMyInstitutionData = {
  filterCategory: 'Engagement',
  filterName: 'ActivityWithMyInstitution',
  filterValue: '',
  addToStore: true,
};
const activityWithMyInstitution = (data: any) => {
  // Check if value is a string or an object

  const { value } = data;
  if (typeof value === 'string') {
    // Check the id to see what the default is
    switch (value.toLocaleLowerCase()) {
      case 'any':
        activityWithMyInstitutionData.filterValue = 'Any';
        break;
      case 'active':
        activityWithMyInstitutionData.filterValue =
          'Active Within_Last_30_Days';
        break;
      case 'inactive':
        activityWithMyInstitutionData.filterValue =
          'InActive Within_Last_30_Days';
        break;
      default:
        break;
    }
  } else {
    // value is an object.
    const { value: ActiveValue } = value;
    const { id } = data;

    activityWithMyInstitutionData.filterValue = `${id} ${ActiveValue}`;
  }
  return activityWithMyInstitutionData;
};

/** *********************Engagement*************************** */

/** *********************Demographics*************************** */
const geographyUSAData = {
  filterCategory: 'Demographics',
  filterName: 'Geography.USA',
  filterValue: undefined,
  addToStore: true,
};
const usa = (value: any) => {
  /*
  This is how the code below deals with user selections for the usa
  deselect USA -- Changes the Table
    target {"id":"selectionUSA","value":"None"}  -- String

  All USA  -- Changes the Table
    target {"value":"Any","id":"selectionUSA"}  -- String

  US regions -- No   
    target {"value":"US Regions","id":"selectionUSA"}

      NorthEast  -- Changes the Table
        target {"value":["Northeast"],"id":"value"}  -- Array

Check, if the value is an array and 1st element is a string.  It's US Regions        

  In-State  -- Changes the Table
    
    target {"value":"In-State","id":"selectionUSA"}  -- String
  
  Out-of-State  -- Changes the Table
    target {"value":"Out-of-State","id":"selectionUSA"}  -- String

  Specific States -- No
     target {"value":"Specific States/Territories","id":"selectionUSA"}
        Maine  -- Changes the Table
           target {"value":[{"label":"Maine (ME)","value":"ME"}],"id":"value"}  -- Array
Check, if the value is an array and 1st element is an object, it's Specific States/Territories 
*/
  /*
    valuel types:
      string = "none" - deselect USA
      string = "any" - selected USA

      array:
        of strings = US Regions 
        of objects = Specific States/Territories
  */

  // The value is a string, set the filter value
  if (typeof value === 'string') {
    geographyUSAData.filterValue = value;
    return geographyUSAData;
  }

  // The value is an array.  Then massage the data, before returning the geographyUSAData object
  if (Array.isArray(value)) {
    geographyUSAData.addToStore = value.length > 0;

    const valueType = typeof value[0];
    if (valueType === 'object') {
      geographyUSAData.filterName = `${
        geographyUSAData.filterName
      }.${'Specific States/Territories'}`;
    } else if (valueType === 'string') {
      geographyUSAData.filterName = `${
        geographyUSAData.filterName
      }.${'US Regions'}`;
    }
    geographyUSAData.filterValue = JSON.stringify(value);
    return geographyUSAData;
  }
  // We have a new type that is not accounted for in the above code.
  geographyUSAData.filterValue = `value type is ${typeof value}`;
  return geographyUSAData;
};

const geographyInternationalData = {
  filterCategory: 'Demographics',
  filterName: 'Geography.International',
  filterValue: undefined,
  addToStore: true,
};
const international = (value: any) => {
  /*
  This is how the code below deals with user selections for an International selection
      deselect
        target {"id":"selectionInternational","value":"None"}

      All International
         target {"value":"Any","id":"selectionInternational"}

      Specific Countries
        target {"value":"Specific Countries","id":"selectionInternational"}
          Canada
             target {"value":[{"label":"Canada (CAN)","value":"CAN"}],"id":"value"}
    */
  if (typeof value === 'string') {
    geographyInternationalData.filterValue = value;
    return geographyInternationalData;
  }

  if (Array.isArray(value)) {
    geographyInternationalData.addToStore = value.length > 0;

    const valueType = typeof value[0];
    if (valueType === 'object') {
      geographyInternationalData.filterName = `${
        geographyInternationalData.filterName
      }.${'Specific Countries'}`;
    }
    geographyInternationalData.filterValue = JSON.stringify(value);
    return geographyInternationalData;
  }
  // We have a new type that is not accounted for in the above code.
  geographyInternationalData.filterValue = `value type is ${typeof value}`;
  return geographyInternationalData;
};
/** *********************Demographics*************************** */

/** *********************ListmemberShip*************************** */
const listLabels = (lists: object[]) =>
  // Return the string of labels from the array
  lists
    .reduce((acc: string[], elem: any) => {
      // Pull the label value out and append to the new string.
      acc.push(elem.label);
      return acc;
    }, [])
    // An array is returned here, but typescript thinks it's an object.
    // @ts-ignore
    .join(',');
/** *********************ListmemberShip*************************** */

/** *********************Prospect Profile*************************** */

// This will keep track of whether or not spring or fall have been checked.  The architecture of hte
// filtesr for ProspectProfile, Term returns an object with both values.  If you check one, then the other, it will send 3 events,
// because the first one has been checked.

const termCheckObj = { spring: false, fall: false };
const termCheck = (value: string, status: boolean) => {
  // Determine whether to update or not.
  const currentStatus = termCheckObj[value];
  // If they are equal status, then we don't need to post a combined analytics event.
  if (currentStatus === status) return false;

  // Update the object and post a combined analytics event
  termCheckObj[value] = status;

  /*
    I only want an event if status is true.
    So if they are not equal, update the value
    and then check status.  If it's true, return it, otherwise, return false
*/
  return status === true;
};

/** *********************Prospect Profile*************************** */
export const filterTrackingHelpers = {
  Engagement: {
    totalTimeSpent,
    dateRegistered,
    activityWithEabNetwork,
    activityWithMyInstitution,
  },
  Demographics: {
    Geography: {
      usa,
      international,
    },
  },
  Listmembership: {
    listLabels,
  },
  PropsectProfile: {
    termCheck,
  },
};
try {
    // @ts-ignore
    removeFilter.displayName = "removeFilter";
    // @ts-ignore
    removeFilter.__docgenInfo = { "description": "", "displayName": "removeFilter", "props": { "toString": { "defaultValue": null, "description": "Returns a string representation of a string.", "name": "toString", "required": false, "type": { "name": "() => string" } }, "charAt": { "defaultValue": null, "description": "Returns the character at the specified index.\n@param pos The zero-based index of the desired character.", "name": "charAt", "required": true, "type": { "name": "(pos: number) => string" } }, "charCodeAt": { "defaultValue": null, "description": "Returns the Unicode value of the character at the specified location.\n@param index The zero-based index of the desired character. If there is no character at the specified index, NaN is returned.", "name": "charCodeAt", "required": true, "type": { "name": "(index: number) => number" } }, "concat": { "defaultValue": null, "description": "Returns a string that contains the concatenation of two or more strings.\n@param strings The strings to append to the end of the string.", "name": "concat", "required": true, "type": { "name": "(...strings: string[]) => string" } }, "indexOf": { "defaultValue": null, "description": "Returns the position of the first occurrence of a substring.\n@param searchString The substring to search for in the string\n@param position The index at which to begin searching the String object. If omitted, search starts at the beginning of the string.", "name": "indexOf", "required": true, "type": { "name": "(searchString: string, position?: number) => number" } }, "lastIndexOf": { "defaultValue": null, "description": "Returns the last occurrence of a substring in the string.\n@param searchString The substring to search for.\n@param position The index at which to begin searching. If omitted, the search begins at the end of the string.", "name": "lastIndexOf", "required": true, "type": { "name": "(searchString: string, position?: number) => number" } }, "localeCompare": { "defaultValue": null, "description": "Determines whether two strings are equivalent in the current locale.\nDetermines whether two strings are equivalent in the current or specified locale.\n@param that String to compare to target string\n@param that String to compare to target string\n@param locales A locale string or array of locale strings that contain one or more language or locale tags. If you include more than one locale string, list them in descending order of priority so that the first entry is the preferred locale. If you omit this parameter, the default locale of the JavaScript runtime is used. This parameter must conform to BCP 47 standards; see the Intl.Collator object for details.\n@param options An object that contains one or more properties that specify comparison options. see the Intl.Collator object for details.", "name": "localeCompare", "required": true, "type": { "name": "{ (that: string): number; (that: string, locales?: string | string[], options?: CollatorOptions): number; }" } }, "match": { "defaultValue": null, "description": "Matches a string with a regular expression, and returns an array containing the results of that search.\nMatches a string or an object that supports being matched against, and returns an array\ncontaining the results of that search, or null if no matches are found.\n@param regexp A variable name or string literal containing the regular expression pattern and flags.\n@param matcher An object that supports being matched against.", "name": "match", "required": true, "type": { "name": "{ (regexp: string | RegExp): RegExpMatchArray; (matcher: { [Symbol.match](string: string): RegExpMatchArray; }): RegExpMatchArray; }" } }, "replace": { "defaultValue": null, "description": "Replaces text in a string, using a regular expression or search string.\nReplaces text in a string, using a regular expression or search string.\nReplaces text in a string, using an object that supports replacement within a string.\nReplaces text in a string, using an object that supports replacement within a string.\n@param searchValue A string to search for.\n@param replaceValue A string containing the text to replace for every successful match of searchValue in this string.\n@param searchValue A string to search for.\n@param replacer A function that returns the replacement text.\n@param searchValue A object can search for and replace matches within a string.\n@param replaceValue A string containing the text to replace for every successful match of searchValue in this string.\n@param searchValue A object can search for and replace matches within a string.\n@param replacer A function that returns the replacement text.", "name": "replace", "required": true, "type": { "name": "{ (searchValue: string | RegExp, replaceValue: string): string; (searchValue: string | RegExp, replacer: (substring: string, ...args: any[]) => string): string; (searchValue: { ...; }, replaceValue: string): string; (searchValue: { ...; }, replacer: (substring: string, ...args: any[]) => string): string; }" } }, "search": { "defaultValue": null, "description": "Finds the first substring match in a regular expression search.\nFinds the first substring match in a regular expression search.\n@param regexp The regular expression pattern and applicable flags.\n@param searcher An object which supports searching within a string.", "name": "search", "required": true, "type": { "name": "{ (regexp: string | RegExp): number; (searcher: { [Symbol.search](string: string): number; }): number; }" } }, "slice": { "defaultValue": null, "description": "Returns a section of a string.\n@param start The index to the beginning of the specified portion of stringObj.\n@param end The index to the end of the specified portion of stringObj. The substring includes the characters up to, but not including, the character indicated by end.\rIf this value is not specified, the substring continues to the end of stringObj.", "name": "slice", "required": true, "type": { "name": "(start?: number, end?: number) => string" } }, "split": { "defaultValue": null, "description": "Split a string into substrings using the specified separator and return them as an array.\nSplit a string into substrings using the specified separator and return them as an array.\n@param separator A string that identifies character or characters to use in separating the string. If omitted, a single-element array containing the entire string is returned.\n@param limit A value used to limit the number of elements returned in the array.\n@param splitter An object that can split a string.\n@param limit A value used to limit the number of elements returned in the array.", "name": "split", "required": true, "type": { "name": "{ (separator: string | RegExp, limit?: number): string[]; (splitter: { [Symbol.split](string: string, limit?: number): string[]; }, limit?: number): string[]; }" } }, "substring": { "defaultValue": null, "description": "Returns the substring at the specified location within a String object.\n@param start The zero-based index number indicating the beginning of the substring.\n@param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end.\rIf end is omitted, the characters from start through the end of the original string are returned.", "name": "substring", "required": true, "type": { "name": "(start: number, end?: number) => string" } }, "toLowerCase": { "defaultValue": null, "description": "Converts all the alphabetic characters in a string to lowercase.", "name": "toLowerCase", "required": true, "type": { "name": "() => string" } }, "toLocaleLowerCase": { "defaultValue": null, "description": "Converts all alphabetic characters to lowercase, taking into account the host environment's current locale.", "name": "toLocaleLowerCase", "required": true, "type": { "name": "(locales?: string | string[]) => string" } }, "toUpperCase": { "defaultValue": null, "description": "Converts all the alphabetic characters in a string to uppercase.", "name": "toUpperCase", "required": true, "type": { "name": "() => string" } }, "toLocaleUpperCase": { "defaultValue": null, "description": "Returns a string where all alphabetic characters have been converted to uppercase, taking into account the host environment's current locale.", "name": "toLocaleUpperCase", "required": true, "type": { "name": "(locales?: string | string[]) => string" } }, "trim": { "defaultValue": null, "description": "Removes the leading and trailing white space and line terminator characters from a string.", "name": "trim", "required": true, "type": { "name": "() => string" } }, "length": { "defaultValue": null, "description": "Returns the length of a String object.", "name": "length", "required": true, "type": { "name": "number" } }, "substr": { "defaultValue": null, "description": "Gets a substring beginning at the specified location and having the specified length.\n@param from The starting position of the desired substring. The index of the first character in the string is zero.\n@param length The number of characters to include in the returned substring.", "name": "substr", "required": true, "type": { "name": "(from: number, length?: number) => string" } }, "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => string" } }, "codePointAt": { "defaultValue": null, "description": "Returns a nonnegative integer Number less than 1114112 (0x110000) that is the code point\nvalue of the UTF-16 encoded code point starting at the string element at position pos in\nthe String resulting from converting this object to a String.\nIf there is no element at that position, the result is undefined.\nIf a valid UTF-16 surrogate pair does not begin at pos, the result is the code unit at pos.", "name": "codePointAt", "required": true, "type": { "name": "(pos: number) => number" } }, "includes": { "defaultValue": null, "description": "Returns true if searchString appears as a substring of the result of converting this\nobject to a String, at one or more positions that are\ngreater than or equal to position; otherwise, returns false.\n@param searchString search string\n@param position If position is undefined, 0 is assumed, so as to search all of the String.", "name": "includes", "required": true, "type": { "name": "(searchString: string, position?: number) => boolean" } }, "endsWith": { "defaultValue": null, "description": "Returns true if the sequence of elements of searchString converted to a String is the\nsame as the corresponding elements of this object (converted to a String) starting at\nendPosition \u2013 length(this). Otherwise returns false.", "name": "endsWith", "required": true, "type": { "name": "(searchString: string, endPosition?: number) => boolean" } }, "normalize": { "defaultValue": null, "description": "Returns the String value result of normalizing the string into the normalization form\nnamed by form as specified in Unicode Standard Annex #15, Unicode Normalization Forms.\nReturns the String value result of normalizing the string into the normalization form\nnamed by form as specified in Unicode Standard Annex #15, Unicode Normalization Forms.\n@param form Applicable values: \"NFC\", \"NFD\", \"NFKC\", or \"NFKD\", If not specified default\ris \"NFC\"\n@param form Applicable values: \"NFC\", \"NFD\", \"NFKC\", or \"NFKD\", If not specified default\ris \"NFC\"", "name": "normalize", "required": true, "type": { "name": "{ (form: \"NFC\" | \"NFD\" | \"NFKC\" | \"NFKD\"): string; (form?: string): string; }" } }, "repeat": { "defaultValue": null, "description": "Returns a String value that is made from count copies appended together. If count is 0,\nthe empty string is returned.\n@param count number of copies to append", "name": "repeat", "required": true, "type": { "name": "(count: number) => string" } }, "startsWith": { "defaultValue": null, "description": "Returns true if the sequence of elements of searchString converted to a String is the\nsame as the corresponding elements of this object (converted to a String) starting at\nposition. Otherwise returns false.", "name": "startsWith", "required": true, "type": { "name": "(searchString: string, position?: number) => boolean" } }, "anchor": { "defaultValue": null, "description": "Returns an <a> HTML anchor element and sets the name attribute to the text value\n@param name", "name": "anchor", "required": true, "type": { "name": "(name: string) => string" } }, "big": { "defaultValue": null, "description": "Returns a <big> HTML element", "name": "big", "required": true, "type": { "name": "() => string" } }, "blink": { "defaultValue": null, "description": "Returns a <blink> HTML element", "name": "blink", "required": true, "type": { "name": "() => string" } }, "bold": { "defaultValue": null, "description": "Returns a <b> HTML element", "name": "bold", "required": true, "type": { "name": "() => string" } }, "fixed": { "defaultValue": null, "description": "Returns a <tt> HTML element", "name": "fixed", "required": true, "type": { "name": "() => string" } }, "fontcolor": { "defaultValue": null, "description": "Returns a <font> HTML element and sets the color attribute value", "name": "fontcolor", "required": true, "type": { "name": "(color: string) => string" } }, "fontsize": { "defaultValue": null, "description": "Returns a <font> HTML element and sets the size attribute value\nReturns a <font> HTML element and sets the size attribute value", "name": "fontsize", "required": true, "type": { "name": "{ (size: number): string; (size: string): string; }" } }, "italics": { "defaultValue": null, "description": "Returns an <i> HTML element", "name": "italics", "required": true, "type": { "name": "() => string" } }, "link": { "defaultValue": null, "description": "Returns an <a> HTML element and sets the href attribute value", "name": "link", "required": true, "type": { "name": "(url: string) => string" } }, "small": { "defaultValue": null, "description": "Returns a <small> HTML element", "name": "small", "required": true, "type": { "name": "() => string" } }, "strike": { "defaultValue": null, "description": "Returns a <strike> HTML element", "name": "strike", "required": true, "type": { "name": "() => string" } }, "sub": { "defaultValue": null, "description": "Returns a <sub> HTML element", "name": "sub", "required": true, "type": { "name": "() => string" } }, "sup": { "defaultValue": null, "description": "Returns a <sup> HTML element", "name": "sup", "required": true, "type": { "name": "() => string" } }, "__@iterator": { "defaultValue": null, "description": "Iterator", "name": "__@iterator", "required": true, "type": { "name": "() => IterableIterator<string>" } }, "padStart": { "defaultValue": null, "description": "Pads the current string with a given string (possibly repeated) so that the resulting string reaches a given length.\nThe padding is applied from the start (left) of the current string.\n@param maxLength The length of the resulting string once the current string has been padded.\rIf this parameter is smaller than the current string's length, the current string will be returned as it is.\n@param fillString The string to pad the current string with.\rIf this string is too long, it will be truncated and the left-most part will be applied.\rThe default value for this parameter is \" \" (U+0020).", "name": "padStart", "required": true, "type": { "name": "(maxLength: number, fillString?: string) => string" } }, "padEnd": { "defaultValue": null, "description": "Pads the current string with a given string (possibly repeated) so that the resulting string reaches a given length.\nThe padding is applied from the end (right) of the current string.\n@param maxLength The length of the resulting string once the current string has been padded.\rIf this parameter is smaller than the current string's length, the current string will be returned as it is.\n@param fillString The string to pad the current string with.\rIf this string is too long, it will be truncated and the left-most part will be applied.\rThe default value for this parameter is \" \" (U+0020).", "name": "padEnd", "required": true, "type": { "name": "(maxLength: number, fillString?: string) => string" } }, "trimLeft": { "defaultValue": null, "description": "Removes whitespace from the left end of a string.", "name": "trimLeft", "required": true, "type": { "name": "() => string" } }, "trimRight": { "defaultValue": null, "description": "Removes whitespace from the right end of a string.", "name": "trimRight", "required": true, "type": { "name": "() => string" } }, "trimStart": { "defaultValue": null, "description": "Returns a copy with leading whitespace removed.", "name": "trimStart", "required": true, "type": { "name": "() => string" } }, "trimEnd": { "defaultValue": null, "description": "Returns a copy with trailing whitespace removed.", "name": "trimEnd", "required": true, "type": { "name": "() => string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/context/ProductAnalytics/CombinedAnalytics/filterTracking.ts#removeFilter"] = { docgenInfo: removeFilter.__docgenInfo, name: "removeFilter", path: "src/shared/context/ProductAnalytics/CombinedAnalytics/filterTracking.ts#removeFilter" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    filterTrackingHelpers.displayName = "filterTrackingHelpers";
    // @ts-ignore
    filterTrackingHelpers.__docgenInfo = { "description": "*********************Prospect Profile***************************", "displayName": "filterTrackingHelpers", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/context/ProductAnalytics/CombinedAnalytics/filterTracking.ts#filterTrackingHelpers"] = { docgenInfo: filterTrackingHelpers.__docgenInfo, name: "filterTrackingHelpers", path: "src/shared/context/ProductAnalytics/CombinedAnalytics/filterTracking.ts#filterTrackingHelpers" };
}
catch (__react_docgen_typescript_loader_error) { }